import React, { useRef, useState } from 'react';
import { IOptionProps } from './Options';

interface IUseOption extends Pick<IOptionProps, 'onFocus' | 'onBlur' | 'wrapped' | 'value' | 'name'> {}

export const useOption = ({ onFocus, onBlur, wrapped, value, name }: IUseOption) => {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const testLabel = value?.toString() ?? ``;
  const testIdLabel = `${name ? `${name}${testLabel ? `.` : ``}` : ``}${testLabel}`;

  const handleOnFocus: React.FocusEventHandler<HTMLInputElement> = (e) => {
    setFocused(true);
    onFocus?.(e);
  };

  const handleOnBlur: React.FocusEventHandler<HTMLInputElement> = (e) => {
    setFocused(false);
    onBlur?.(e);
  };

  const inputClick = () => {
    inputRef?.current?.click();
  };

  const handleOnWrapperClick: React.MouseEventHandler = (e) => {
    if (e.target instanceof HTMLAnchorElement || e.target instanceof HTMLInputElement) {
      return e.stopPropagation();
    }
    wrapped && inputClick();
  };

  const handleOnTextClick: React.MouseEventHandler = () => {
    !wrapped && inputClick(); // Note: Parent wrapper will handle the trigger if wrapped
  };

  return {
    focused,
    handleOnFocus,
    handleOnBlur,
    handleOnWrapperClick,
    handleOnTextClick,
    inputRef,
    testIdLabel
  };
};
